export const FILTER_ALL = 'all';
export const FILTER_ERRORS = 'errors';
export const FILTER_SKIPPED = 'skipped';
